<template>
    <el-switch :value="value" @change="inputHandler" />
</template>

<script>
export default {
    name: "ISwitch",
    props: ["value", "widget"],
    methods: {
        inputHandler(newValue) {
            this.$emit("change", newValue);
        }
    }
};
</script>

<style></style>
